module.exports = __webpack_public_path__ + "static/media/polandTagsMobileSmall.86a2ddd0.png";